import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../../../../../CloudStorage/LoadCSSforfirstTime";
import { useParams } from "react-router-dom";
import { getPostsById } from "../../../../../../../redux/posts/action";
import { useDispatch, useSelector } from "react-redux";
import MineActiveJobOverview from "./MineActiveJobOverview";
import MineActiveMessagesandFiles from "./MineActiveMessagesandFiles";
import MineActiveTimesheet from "./MineActiveTimesheet";
import { useRouteBaseStateContext } from "../../../../../../../Context/RouteBaseStateContext";
import HelpSupportModal from "../../../../../../Common/HelpSupport/HelpSupportModal";
import { decodeHtml } from "../../../../../../../assests/extention/commonfunction";

export default function MineActiveJobAllTabs() {
  const { urlstate, setMyorderActivejobsroute } = useRouteBaseStateContext();

  const { id } = useParams();
  const path = "Assets/scss/FindWork.module.scss";
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("JobOverview");
  const [theModal, setTheModal] = useState(false);
  const [proposalmilestones, setProposalmilestones] = useState(null);

  const posts = useSelector(({ posts: { postbyid } }) => postbyid);

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  useEffect(() => {
    dispatch(getPostsById(id));
  }, [id, dispatch]);

  useEffect(() => {
    if (Array.isArray(posts?.proposal) && posts?.is_mine == 1) {
      setProposalmilestones(posts.proposal[0]);
    } else if (Array.isArray(posts?.my_proposal) && posts?.is_mine == 0) {
      setProposalmilestones(posts.my_proposal[0]);
    }
  }, [posts]);

  useEffect(() => {
    if (urlstate?.myorderactivejobsroute) {
      setActiveTab(urlstate?.myorderactivejobsroute || "JobOverview");
    } else {
      setActiveTab("JobOverview");
    }
  }, [urlstate, urlstate?.myorderactivejobsroute]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setMyorderActivejobsroute(tab);
  };


  return (
    <div className="project-section">
      <div style={{
        display: "flex",
          alignItems:'center',
        justifyContent: "space-between"
      }}>
        <h4>{decodeHtml(posts?.title)}</h4>
        <button className="background-button btn" onClick={() => setTheModal(true)} >Dispute</button>
      </div>
      <div className="col-12 mob-pad">
        <ul className="nav nav-tabs">
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab == "JobOverview" ? "active" : ""}`}
              onClick={() => handleTabClick("JobOverview")}
            >
              Job Overview
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab == "Messages" ? "active" : ""}`}
              onClick={() => handleTabClick("Messages")}
            >
              Messages and files
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab == "Timesheet" ? "active" : ""}`}
              onClick={() => handleTabClick("Timesheet")}
            >
              Timesheet
            </a>
          </li>
        </ul>
        <div className="tab-content">
          <div
            className={`tab-pane ${activeTab == "JobOverview" ? "active" : ""}`}
            id="JobOverview"
          >
            <MineActiveJobOverview
              posts={posts}
              proposalmilestones={proposalmilestones}
            />
          </div>
          <div
            className={`tab-pane ${activeTab == "Messages" ? "active" : ""}`}
            id="Messages"
          >
            <MineActiveMessagesandFiles
              posts={posts}
              proposalmilestones={proposalmilestones}
            />
          </div>
          <div
            className={`tab-pane ${activeTab == "Timesheet" ? "active" : ""}`}
            id="Timesheet"
          >
            <MineActiveTimesheet
              posts={posts}
              proposalmilestones={proposalmilestones}
            />
          </div>
        </div>
        <HelpSupportModal
          theModal={theModal}
          setTheModal={setTheModal}
          data={posts}
          masterID={id}
          masterType="9"
        />
      </div>
    </div>
  );
}
